import { createTheme } from "@mui/material/styles";
import { responsiveFontSizes } from "@mui/material";
import CssBaseline from '@mui/material/CssBaseline';

const FONT_PRIMARY = 'Public Sans, sans-serif';
function pxToRem(value: number) {
  return `${value / 16}rem`;
}

let theme = createTheme({
  palette: {
    background: {
      default: "#EFEFEF",
      //paper: '#E3CAA5',
    },
    primary: {
      main: "#58342c",
    },
    secondary: {
      main: "#C68B59",
    },
    error: {
      main: "#ff3b30",
    },
    warning: {
      main: "#fecb1e",
    },
    info: {
      main: "#2aa5e9",
    },
    success: {
      main: "#3EC70B",
    },
  },
  typography: {
    fontFamily: FONT_PRIMARY,
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    fontWeightBold: 700,
    h1: {
      fontWeight: 700,
      lineHeight: 80 / 64,
      fontSize: pxToRem(40)
    },
    h2: {
      fontWeight: 700,
      lineHeight: 64 / 48,
      fontSize: pxToRem(32)
    },
    h3: {
      fontWeight: 700,
      lineHeight: 1.5,
      fontSize: pxToRem(24),
    },
    h4: {
      fontWeight: 700,
      lineHeight: 1.5,
      fontSize: pxToRem(20),
    },
    h5: {
      fontWeight: 700,
      lineHeight: 1.5,
      fontSize: pxToRem(18)
    },
    h6: {
      fontWeight: 700,
      lineHeight: 28 / 18,
      fontSize: pxToRem(17),
    },
    subtitle1: {
      fontWeight: 600,
      lineHeight: 1.5,
      fontSize: pxToRem(16)
    },
    subtitle2: {
      fontWeight: 600,
      lineHeight: 22 / 14,
      fontSize: pxToRem(14)
    },
    body1: {
      lineHeight: 1.5,
      fontSize: pxToRem(16)
    },
    body2: {
      lineHeight: 22 / 14,
      fontSize: pxToRem(14)
    },
    caption: {
      lineHeight: 1.5,
      fontSize: pxToRem(12)
    },
    overline: {
      fontWeight: 700,
      lineHeight: 1.5,
      fontSize: pxToRem(12),
      letterSpacing: 1.1,
      textTransform: 'uppercase'
    },
    button: {
      fontWeight: 700,
      lineHeight: 24 / 14,
      fontSize: pxToRem(14),
      textTransform: 'capitalize'
    },
  },
  
});

theme = responsiveFontSizes(theme);

export default theme;
